import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ParentState {
  studentIds: number[];
  studentIdpIds: string[];
  studentSchoolYear: number[];
  studentFullName: string[];
}

const initialState: ParentState = {
  studentIds: [],
  studentIdpIds: [],
  studentSchoolYear: [],
  studentFullName: [],
};

const parentSlice = createSlice({
  name: "parent",
  initialState,
  reducers: {
    setStudentIds: (state, action: PayloadAction<number[]>) => {
      state.studentIds = action.payload;
    },
    setStudentIdpIds: (state, action: PayloadAction<string[]>) => {
      state.studentIdpIds = action.payload;
    },
    setStudentSchoolYear: (state, action: PayloadAction<number[]>) => {
      state.studentSchoolYear = action.payload;
    },
    setStudentFullName: (state, action: PayloadAction<string[]>) => {
      state.studentFullName = action.payload;
    },
  },
});

export const {
  setStudentIds,
  setStudentIdpIds,
  setStudentSchoolYear,
  setStudentFullName,
} = parentSlice.actions;
export default parentSlice.reducer;
